import { NgModule, ModuleWithProviders, NO_ERRORS_SCHEMA } from '@angular/core';
import { SharedModule } from '../shared/shared.module';

import { AnimationsService } from './animations.service';

import { TemplateComponent } from './template/template.component';
import { TestComponent } from './test/test.component';
import { TriptychLineHorStepsComponent } from './triptych-line-hor-steps/triptych-line-hor-steps.component';
import { DemoAbnTriptychLineHorStepsComponent } from './demo-abn-triptych-line-hor-steps/demo-abn-triptych-line-hor-steps.component';
import { DemoBfsTriptychLineHorStepsComponent } from './demo-bfs-triptych-line-hor-steps/demo-bfs-triptych-line-hor-steps.component';
import { DemoDestatisTriptychLineHorStepsComponent } from './demo-destatis-triptych-bar-hor-steps/demo-destatis-triptych-bar-hor-steps.component';
import { DemoHessenTriptychLineHorStepsComponent } from './demo-hessen-triptych-line-hor-steps/demo-hessen-triptych-line-hor-steps.component';
import { DemoRaboTriptychBarVertStepsComponent} from './demo-rabo-triptych-bar-vert-steps/demo-rabo-triptych-bar-vert-steps.component';
import { DemoRlpTriptychBarVertStepsComponent} from './demo-rlp-triptych-bar-vert-steps/demo-rlp-triptych-bar-vert-steps.component';
import { DemoTilastokeskusTriptychLineHorStepsComponent } from './demo-tilastokeskus-triptych-line-hor-steps/demo-tilastokeskus-triptych-line-hor-steps.component';
import { DemoTilastokeskusLineComponent } from './demo-tilastokeskus-line/demo-tilastokeskus-line.component';
import { DemoDSTTriptychLineHorStepsComponent } from './demo-dst-triptych-line-hor-steps/demo-dst-triptych-line-hor-steps.component';
import { DemoStatbelTriptychBarComponent } from './demo-statbel-triptych-bar/demo-statbel-triptych-bar.component';
import { DemoStatistikamtnordTriptychBarHorStepsComponent } from './demo-statistikamtnord-triptych-bar-steps/demo-statistikamtnord-triptych-bar-hor-steps.component';
import { DemoSatTriptychLineHorStepsComponent } from './demo-sat-triptych-line-hor-steps/demo-sat-triptych-line-hor-steps.component';
import { DemoSCBTriptychLineHorStepsComponent } from './demo-scb-triptych-line-hor-steps/demo-scb-triptych-line-hor-steps.component';


@NgModule({
  imports: [
    SharedModule,
  ],
  declarations: [
    DemoAbnTriptychLineHorStepsComponent,
    DemoBfsTriptychLineHorStepsComponent,
    DemoDestatisTriptychLineHorStepsComponent,
    DemoHessenTriptychLineHorStepsComponent,
    DemoRaboTriptychBarVertStepsComponent,
    DemoRlpTriptychBarVertStepsComponent,
    DemoStatbelTriptychBarComponent,
    DemoStatistikamtnordTriptychBarHorStepsComponent,
    DemoSatTriptychLineHorStepsComponent,
    TemplateComponent,
    TestComponent,
    TriptychLineHorStepsComponent,
    DemoTilastokeskusTriptychLineHorStepsComponent,
    DemoTilastokeskusLineComponent,
    DemoDSTTriptychLineHorStepsComponent,
    DemoSCBTriptychLineHorStepsComponent,
  ],
  entryComponents: [
    DemoAbnTriptychLineHorStepsComponent,
    DemoBfsTriptychLineHorStepsComponent,
    DemoDestatisTriptychLineHorStepsComponent,
    DemoHessenTriptychLineHorStepsComponent,
    DemoRaboTriptychBarVertStepsComponent,
    DemoRlpTriptychBarVertStepsComponent,
    DemoStatbelTriptychBarComponent,
    DemoStatistikamtnordTriptychBarHorStepsComponent,
    DemoSatTriptychLineHorStepsComponent,
    TemplateComponent,
    TestComponent,
    TriptychLineHorStepsComponent,
    DemoTilastokeskusTriptychLineHorStepsComponent,
    DemoTilastokeskusLineComponent,
    DemoDSTTriptychLineHorStepsComponent,
    DemoSCBTriptychLineHorStepsComponent,
  ],
  exports: [
    DemoAbnTriptychLineHorStepsComponent,
    DemoBfsTriptychLineHorStepsComponent,
    DemoDestatisTriptychLineHorStepsComponent,
    DemoHessenTriptychLineHorStepsComponent,
    DemoRaboTriptychBarVertStepsComponent,
    DemoRlpTriptychBarVertStepsComponent,
    DemoStatbelTriptychBarComponent,
    DemoStatistikamtnordTriptychBarHorStepsComponent,
    DemoSatTriptychLineHorStepsComponent,
    TemplateComponent,
    TestComponent,
    TriptychLineHorStepsComponent,
    DemoTilastokeskusTriptychLineHorStepsComponent,
    DemoTilastokeskusLineComponent,
    DemoDSTTriptychLineHorStepsComponent,
    DemoSCBTriptychLineHorStepsComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class AnimationsModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AnimationsModule,
      providers: [ AnimationsService ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/animations/animations.module.ts